import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtTabController from "../../components/NtTabController";
import NtModalInputTitle from "../../components/NtModalInputTitle";
import NtText from "../../components/NtText";
import { useTheme } from "../../context/ThemeContext";
import hardwaretimezonedata from "../data/hardwaretimezonedata";

function NtHardwareTimezonePicker({ containerStyle, selection, onPress }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={[styles.container, containerStyle]}>
      <NtModalInputTitle style={{ marginLeft: 4, marginBottom: 4 }}>
        Time Zone *
      </NtModalInputTitle>
      <NtTabController
        options={hardwaretimezonedata}
        selection={selection}
        onPress={onPress}
      />
      <NtText style={styles.footer}>
        Note: timezone is the same for both accounts.
      </NtText>
    </View>
  );
}

const makeStyles = (t) => StyleSheet.create({
  container: { marginBottom: 8 },
  footer: {
    fontSize: 11,
    fontWeight: "500",
    color: t.textMute,
    fontStyle: "italic",
    marginTop: 6,
    marginLeft: 4,
  },
});

export default NtHardwareTimezonePicker;
